import React from 'react';
import { motion } from 'framer-motion';
import { Building2, MapPin, PlusCircle, BarChart3, Users, ClipboardList } from 'lucide-react';
import { CLIENTS } from '../../utils/constants';
import { fadeInUp, staggerContainer, staggerItem } from '../../utils/animations';

const icons = [Building2, MapPin, PlusCircle, BarChart3, Users, ClipboardList];

const ClientsSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.p
            className="text-brand-500 font-semibold text-sm uppercase tracking-wider mb-3"
            variants={fadeInUp}
          >
            Our Clients
          </motion.p>
          <motion.h2
            className="text-3xl sm:text-4xl text-neutral-900 leading-tight"
            style={{ fontFamily: "'Livvic', sans-serif", fontWeight: 700 }}
            variants={fadeInUp}
          >
            Who We Work With
          </motion.h2>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {CLIENTS.map((client, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                className="flex items-center space-x-4 bg-neutral-50 rounded-xl p-5 border border-neutral-100"
                variants={staggerItem}
              >
                <div className="w-10 h-10 bg-brand-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  {Icon && <Icon size={20} className="text-brand-500" />}
                </div>
                <span className="text-neutral-700 font-medium" style={{ fontFamily: "'Livvic', sans-serif" }}>{client}</span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;